import Button from '@material-ui/core/Button';
import * as React from 'react';
import './volunteer.css';

export class Volunteer extends React.Component {
  public render() {
    return (
      <div className="volunteer">
        <h2>Volunteers are needed for Wednesday through Sunday</h2>

        <h4>Earn 2 VIP Beverage Tickets per hour volunteered</h4>

        <ol>
          <li>Click on a Day Button below</li>
          <li>Select a time and task that fits your schedule</li>
          <li>Click the "Submit and Sign Up" button</li>
          <li>Fill in your Name and Email Address</li>
          <li>Click the "Sign Up Now" button</li>
          <li>View the Confirmation Email</li>
        </ol>

        <a href="http://www.signupgenius.com/go/10c0b4cadad2dabf58-funfest3" target="_blank" rel="noopener noreferrer">
          <Button variant="contained" color="primary">
            Tues/Weds June 4th &amp; 5th
          </Button>
        </a>
        <a href="http://www.signupgenius.com/go/10c0b4cadad2dabf58-funfest" target="_blank" rel="noopener noreferrer">
          <Button variant="contained" color="primary">
            Thurs June 6th
          </Button>
        </a>
        <a href="http://www.signupgenius.com/go/10c0b4cadad2dabf58-funfest1" target="_blank" rel="noopener noreferrer">
          <Button variant="contained" color="primary">
            Fri June 7th
          </Button>
        </a>
        <a href="http://www.signupgenius.com/go/10c0b4cadad2dabf58-funfest2" target="_blank" rel="noopener noreferrer">
          <Button variant="contained" color="primary">
            Sat June 8th
          </Button>
        </a>
        <a href="http://www.signupgenius.com/go/10c0b4cadad2dabf58-funfest4" target="_blank" rel="noopener noreferrer">
          <Button variant="contained" color="primary">
            Sun June 9th
          </Button>
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Volunteer/index.tsx